import styled, { createGlobalStyle } from 'styled-components';

import { mediaMin } from '@spa/shared/theme';
import { Box, Wrapper } from '@spa/shared/components/Modal/styles';
import { ClearFilters, ClearFiltersWrapper } from '@spa/shared/components/Search/FloatingBox/Filters/styles';
import { GroupContainer } from '@spa/shared/components/Filters/Group/styles';
import { Container as TenantCounter } from '@spa/shared/components/Filters/TenantCounter/styles';

export const GlobalStyleDesktop = createGlobalStyle`
  body {
    ${Box} {
      border-radius: 0;
      background: ${props => props.theme.colors.pearlWhite};

      svg.close-icon {
        background-color: transparent;
      }
    }
  }
`;

export const GlobalStyleMobile = createGlobalStyle`
  body {
    ${Wrapper} {
      z-index: 5;
    }

    ${Box} {
      border-radius: 0;
      background: ${props => props.theme.colors.pearlWhite};
      width: 100%;
      height: 100%;

      svg.close-icon {
        background-color: transparent;
      }
    }

    ${ClearFilters} {
      ${mediaMin.smallBreakpoint`
        position: relative;
        text-align: right;
        top: ${props => props.theme.space(-2.5)};
        right: ${props => props.theme.space(-3)};
      `}
    }

    ${ClearFiltersWrapper} {
      padding-top: ${props => props.theme.space(3)};
      padding-bottom: ${props => props.theme.space(3)};
      width: 100%;
      height: 64px;
      margin-left: unset;
      margin-right: unset;

      & > button:first-of-type {
        position: initial;
      }
    }

    ${GroupContainer} {
      ${mediaMin.smallBreakpoint`
        &:not(:first-child) {
          margin-bottom: ${props => props.theme.space(6)};
        }
      `}
    }

    ${TenantCounter} {
      margin: 0;
    }
  }
`;

export const FiltersWithoutGroup = styled.div`
  margin-bottom: 10px;
`;
